import Image from '../../Image';
import Link from '../../Link';
import { IAttribute } from '../../interfaces';

export default function SelectCardAttribute({
    attribute,
    urlSport,
}: {
    attribute: IAttribute;
    urlSport: string;
}): JSX.Element {
    return (
        <Link
            href={`${attribute.url !== '#' ? urlSport + attribute.url : '#'}`}
            className={`${attribute.url !== '#' ? '' : 'cursor-not-allowed '}`}
        >
            <div className={`${attribute.url !== '#' ? 'cursor-pointer sport-zoom' : ''}`}>
                <div className="flex relative z-10 flex-col opacity-1  " style={{ maxWidth: 500, maxHeight: 250 }}>
                    <Image
                        imgClassName={`${attribute.url !== '#' ? '' : ' opacity-50 '}`}
                        src={attribute.image}
                        alt={attribute.alt}
                    />
                    <div className="absolute z-20">
                        <div className="ml-4 md:ml-7 mt-6 mr-6 text-sm-blue-primary text-left ">
                            <p
                                className="text-xl font-bold italic ;
"
                            >
                                {attribute.title}
                            </p>
                            <p className="leading-tight w-2/3  md:w-11/12	">{attribute.content}</p>
                        </div>
                    </div>

                    <div className="absolute z-20 top-20 right-5">
                        <div className="ml-3 md:ml-7 mt-6 mr-6 text-sm-blue-primary text-center ">
                            <p
                                className={`${
                                    attribute.url !== '#' && !attribute.new ? 'hidden' : 'block'
                                } leading-tight Z-50 w-full md:w-96 bg-sm-blue-primary opacity-80 py-4 my-3 px-4 rounded-xl font-extrabold text-white`}
                            >
                                {attribute.new ? 'NEW' : 'PRONTO'}
                            </p>
                        </div>
                    </div>

                    <div className="absolute z-20 ml-7 bottom-3 ">
                        <Image
                            imgClassName={`${attribute.url !== '#' ? '' : ' opacity-50 '}`}
                            src={attribute.icon.image}
                            alt={attribute.alt}
                            height={attribute.icon.height}
                            width={attribute.icon.width}
                        />
                    </div>
                </div>
            </div>
        </Link>
    );
}
